import { state } from "@src/state";
export const selectLiveChat = () => state.meeting.studio.stream.liveChat;
export const selectIsLiveChatOpen = () => state.meeting.studio.stream.liveChat.isOpen;
export const selectIsLiveChatToggle = () => state.meeting.studio.stream.liveChat.isToggle;
export const selectLiveChatActiveTabIndex = () => state.meeting.studio.stream.liveChat.activeTabIndex;
export const selectLiveChatMessages = () => state.meeting.studio.stream.liveChat.messages;
